import { Wallpaper } from '@wetransfer/transfer/store/customWallpapers';

import { SURVEY_URL } from './constants';
import I18n from '@wetransfer/transfer/modules/i18n';
import { WallpaperCategory } from '../TransferCustomizationProvider/types';

export const getWallpaperThumbnail = (wallpaper: Wallpaper): string => {
  return (
    wallpaper.srcSmall ||
    wallpaper.srcMedium ||
    wallpaper.srcLarge ||
    wallpaper.localFileSrc
  );
};

export const blurImageUrl = (url: string, radius = 100): Promise<string> =>
  new Promise(function (resolve) {
    const img = new Image();

    img.onload = function () {
      const w = img.naturalWidth;
      const h = img.naturalHeight;
      const canvas = document.createElement('canvas');
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      canvas.width = w;
      canvas.height = h;
      const context = canvas.getContext('2d');
      context.filter = 'blur(' + radius + 'px)';
      context.drawImage(img, -radius, -radius, w + radius * 2, h + radius * 2);
      canvas.toBlob(function (blob) {
        resolve(URL.createObjectURL(blob));
      });
    };
    img.src = url;
  });

enum SurveyCustomPropertyName {
  subscription = 's',
  userId = 'u',
  country = 'c',
}

const getCustomPropertyName = (
  longName: keyof SurveyCustomPropertyName
): SurveyCustomPropertyName | undefined => {
  switch (longName) {
    case 'subscription':
      return SurveyCustomPropertyName.subscription;
    case 'userId':
      return SurveyCustomPropertyName.userId;
    case 'country':
      return SurveyCustomPropertyName.country;
    default:
      return undefined;
  }
};

export const getSurveyUrl = (params: {
  subscription?: string;
  userId?: string;
  country?: string;
}): string => {
  const paramString = Object.keys(params)
    .map<string>((key: keyof typeof params) =>
      params[key]
        ? `${getCustomPropertyName(key as keyof SurveyCustomPropertyName)}=${
            params[key]
          }`
        : ''
    )
    .filter((param) => Boolean(param))
    .join('&');

  return `${SURVEY_URL}#${paramString}`;
};

export const getDescriptiveText = (wallpaper: Wallpaper): string => {
  return wallpaper.category === WallpaperCategory.CURATED
    ? I18n.t(`custom-wallpaper.curated_description.${wallpaper.descrId}`)
    : wallpaper.category === WallpaperCategory.CUSTOM
    ? I18n.t('custom-wallpaper.custom_description')
    : '';
};
